import _styled from "@emotion/styled/base";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconChevronTop, IconChevronBottom } from '@travel-frontend/icons';
import { forwardRef, useCallback, useRef, useState } from 'react';
import { Caption } from '../../primitives/Accordion/components/Caption.js';
import { Container } from '../../primitives/Accordion/components/Container.js';
import { Collapse } from '../../primitives/Collapse/Collapse.js';
import { Stack } from '../../primitives/Stack/Stack.js';
import { SPACING_NONE } from '../../utils/spacingLegacy.js';
export const Accordion = /*#__PURE__*/_styled(forwardRef(({
  caption,
  children,
  scrollIntoView = false,
  expanded = false,
  withoutBorder = false,
  ...restProps
}, ref) => {
  const captionRef = useRef(null);
  const [contentsVisible, setContentsVisible] = useState(expanded);
  const handleClick = useCallback(() => {
    if (!captionRef.current) {
      return;
    }
    if (!contentsVisible && scrollIntoView) {
      captionRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setContentsVisible(previous => !previous);
  }, [contentsVisible, scrollIntoView]);
  return _jsxs(Container, {
    ...restProps,
    ref: ref,
    withoutBorder: withoutBorder,
    expanded: contentsVisible,
    children: [_jsx(Stack, {
      direction: "row",
      spacing: SPACING_NONE,
      justifyContent: "flex-start",
      children: _jsxs(Caption, {
        ref: captionRef,
        onClick: handleClick,
        children: [caption, children && (contentsVisible ? _jsx(IconChevronTop, {}) : _jsx(IconChevronBottom, {}))]
      })
    }), _jsx(Stack, {
      children: _jsx(Collapse, {
        in: contentsVisible,
        children: children
      })
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "ey5vzwa0"
} : {
  target: "ey5vzwa0",
  label: "Accordion"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");